export default {
  advisor: 'spy',
  apply: 'checkmark',
  changelog: 'fork',
  changelogBugfix: 'bug',
  changelogFeature: 'trophy',
  changelogImprovement: 'wizard',
  close: 'x',
  confirm: 'checkmark',
  confirmed: 'bookmark',
  contract: 'compress',
  create: 'plus',
  customer: 'user',
  dateCreated: 'calendar',
  dateInvoice: 'calendar outline',
  dateOrder: 'calendar',
  dateReceipt: 'add to calendar',
  dateScanned: 'calendar check',
  delete: 'trash',
  description: 'align justify',
  designerQueue: 'tasks',
  edges: 'block layout',
  email: 'mail',
  error: 'warning sign',
  expand: 'expand arrows alternate',
  exportToExcel: 'file excel outline',
  factory: 'producer',
  feedback: 'talk',
  firstName: 'tag',
  height: 'resize vertical',
  homeModule: 'dashboard',
  id: 'hashtag',
  inStock: 'check',
  invoiceNumber: 'file text outline',
  knotting: 'share alternate',
  lastLogin: 'calendar',
  lastName: 'tag',
  markedForDesigners: 'pin',
  markedForDesignersModule: 'pin',
  myOrdersModule: 'spy',
  mySearchesModule: 'save',
  name: 'tag',
  no: 'x',
  onConsignment: 'external',
  paginationNext: 'right chevron',
  paginationPrevious: 'left chevron',
  password: 'lock',
  picture: 'picture',
  pictureCount: 'file image outline',
  picturePrimary: 'star',
  pictureQC: 'warning sign',
  pictureSource: 'camera',
  quality: 'share alternate',
  question: 'question circle',
  request: 'feed',
  requestedRugModule: 'feed',
  reservation: 'bookmark',
  reset: 'erase',
  save: 'save',
  search: 'search',
  searchModule: 'search',
  send: 'mail',
  setting: 'setting',
  settings: 'settings',
  signOut: 'log out',
  size: 'expand',
  sizeQm: 'expand',
  sold: 'x',
  status: 'shopping basket',
  statusModule: 'eye',
  success: 'checkmark',
  takenBy: 'user circle outline',
  unknown: 'warning sign',
  user: 'user',
  userAdd: 'add user',
  users: 'users',
  warning: 'info',
  width: 'resize horizontal',
  yes: 'checkmark',
}
